import { useState } from "react";
import {
  FaClock,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaPhone,
} from "react-icons/fa";

import "./ContactLanding.css";

const CONTACT_ITEMS = [
  { icon: FaMapMarkerAlt, label: "Dirección", value: "Santiago del Estero 666, Santa Rosa" },
  { icon: FaPhone, label: "Teléfono", value: "+54 2954 313911" },
  { icon: FaEnvelope, label: "Email", value: "administracion@fundacioncolegiosantotomas.com.ar" },
  { icon: FaClock, label: "Horario", value: "Lunes a viernes" },
];

export default function ContactLanding() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });

  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));

  const submit = (event) => {
    event.preventDefault();
    const subject = encodeURIComponent(`Consulta web de ${form.name}`);
    const body = encodeURIComponent(
      `Nombre: ${form.name}\nEmail: ${form.email}\nTeléfono: ${form.phone || "No informado"}\n\n${form.message}`,
    );
    window.location.href = `mailto:administracion@fundacioncolegiosantotomas.com.ar?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <main className="tc-contact-page">
        <div className="tc-contact-main">
          <section className="tc-contact-copy">
            <span>Contacto</span>
            <h1>Conversemos</h1>
            <div className="tc-contact-line" />
            <p>¿Querés conocer más sobre nuestra propuesta educativa o agendar una visita? Escribinos y te responderemos a la brevedad.</p>
          </section>

          <form className="tc-contact-form" onSubmit={submit}>
            <div className="tc-contact-row">
              <label>
                Nombre
                <input value={form.name} onChange={update("name")} required />
              </label>
              <label>
                Email
                <input type="email" value={form.email} onChange={update("email")} required />
              </label>
            </div>
            <label>
              Teléfono
              <input type="tel" value={form.phone} onChange={update("phone")} />
            </label>
            <label>
              Mensaje
              <textarea
                rows="5"
                placeholder="Contanos en qué podemos ayudarte"
                value={form.message}
                onChange={update("message")}
                required
              />
            </label>
            <button type="submit"><FaPaperPlane /> Enviar mensaje</button>
            <small>Al enviar se abrirá tu aplicación de correo con el mensaje preparado.</small>
          </form>
        </div>

        <section className="tc-contact-details" aria-label="Datos de contacto">
          {CONTACT_ITEMS.map((item) => (
            <article key={item.label}>
              <span><item.icon /></span>
              <div><strong>{item.label}</strong><p>{item.value}</p></div>
            </article>
          ))}
        </section>
      </main>
    </>
  );
}
